/** Tokens de marca compartilhados (JS) — espelha theme.css */

export const brandColors = {
  background: '#F5F0E6',
  surface: '#FFFFFF',
  surfaceMuted: '#F8F4EC',
  textPrimary: '#1F4F4F',
  textSecondary: '#5A6A6A',
  highlight: '#50B0A0',
  accent: '#B89040',
  accentHover: '#A07E36',
  shell: '#1F4F4F',
  shellDeep: '#163D3D',
  success: '#2F9E6F',
  danger: '#D64545',
  warning: '#E6A23C',
  info: '#50B0A0',
  border: '#E8E2D6',
  white: '#FFFFFF',
};

/** Paleta de gráficos derivada da marca (sem rainbow SaaS). */
export const chartPalette = [
  '#1F4F4F',
  '#B89040',
  '#50B0A0',
  '#2F6B6B',
  '#D4A84B',
  '#7BC4B8',
  '#D64545',
  '#A07E36',
  '#3FA896',
  '#C49A45',
];

export const statusColor = (positive) =>
  positive ? brandColors.success : brandColors.danger;
